import { gql } from '@apollo/client';

export const GetStatistics = gql`
  query GetStatistics {
    notificationStats {
      sent
      read
    }
    userStatsByStatus {
      status
      count
    }
    userStatsByPlatform {
      type
      count
    }
    gameStats {
      totalGames
      totalRounds
      avgPlayersPerGame
      maxPlayersPerGame
      topPlayers {
        firstName
        lastName
        gamesPlayed
        totalScore
      }
      packStats {
        pack
        count
      }
    }
  }
`;
